import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { bedrukker, bedrukker10, bedrukker15 } from '../../../Config/constants'

export default function ShowFilesDialog(props) {

    const classes = useStyles();

    function PaperComponent(props) {
        return (
            <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
                <Paper {...props} />
            </Draggable>
        );
    }

    const getDialogContent = () => {
        let printingMetaData = JSON.parse(props.productionOrder.bolMetaData).find(y => y.MetaDataType === 1).MetaData.find(x => (x.Name === bedrukker || x.Name === bedrukker10 || x.Name === bedrukker15))
        let productAttachments = JSON.parse(props.productionOrder.bomOut[0].productMetaData).find(y => y.MetaDataType === 2).MetaData[0].Attachments
        let dialogContent = null
        let description2 = ""
        if (printingMetaData) {
            if (printingMetaData.Description.length > 1) {
                description2 = printingMetaData.Description[1]
            }
        }

        dialogContent =
            <React.Fragment>
                {productAttachments.map((x, filesIndex) =>
                    <img key={"filesIndex_" + filesIndex} className={classes.imageContainer} src={`data:image/jpeg;base64,${x}`} />
                )}
                <div>{description2}</div>
            </React.Fragment>

        return dialogContent
    }

    return (

        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {props.dialogTitle}
            </DialogTitle>
            <DialogContent >
                <DialogContentText className={classes.dialogContext}>
                    {getDialogContent()}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.okButton} autoFocus onClick={props.action}>
                        OK
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles(() => ({

    dialogContainer: {
        margin: "auto"
    },
    buttons: {
        width: "100%",
        textAlign: "center"
    },
    imageContainer: {
        maxWidth: "750px"
    },
    okButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        margin: "3px",
        width: "50px",
        marginBottom: "20px"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "20px",
        cursor: 'move',
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    }
}));
